import React from "react";
import _get from "lodash/get";
import html2pdf from "html2pdf.js";
import { Alert } from "@mui/lab";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { pdfOptions } from "../../helpers/helpers";
import { formatDate, formatTime } from "../../actions/momentActions";
import {
  getEqpLogs,
  getIftaLogs,
  updateStateMileage,
} from "../../actions/stateMileageActions";
import { getProfile } from "../../actions/auth/authActions";
import CircularProgress from "@mui/material/CircularProgress";
import SearchBar from "../../components/SearchBar";
import MileTable from "./mileTable";
import { LABELS as _LABELS } from "../../language";
import { getMeterToMi, parseStateMileage } from "./helpers";

const LABELS = _LABELS.adminPage;

class StateMileage extends React.Component {
  state = {
    limit: 10,
    page: 0,
    prefix: 1,
    loading: false,
    search: false,
    allRoutes: [],
  };

  // async componentDidMount() {
  //     await this.props.getEquipments({ skip: 0, limit: 250 });

  // }

  getEqpLogs2 = async () => {
    const { vehicleId, start, end } = this.state;
    if (!vehicleId) {
      this.setState({
        errorMessage: LABELS.selectVehicle,
        loading: false,
      });
    } else {
      try {
        this.setState({ loading: true, errorMessage: "", allRoutes: [] });

        const vehicle = this.props.equipments.filter(
          (item) => item.id === vehicleId
        );
        this.setState({ vehicle });
        const iftaLogs = await this.props.getIftaLogs({
          vehicleId: vehicleId,
          from: start,
          to: end,
        });

        console.log(">>>", iftaLogs.statemiles);
        const allStatus = (iftaLogs.statemiles || []).filter(
          (e) =>
            Array.isArray(e.coordinates) &&
            e.coordinates.length === 2 &&
            e.coordinates[0] !== 0
        );

        if (allStatus && Array.isArray(allStatus) && allStatus.length > 1) {
          this.getStateMileage(allStatus);
        } else {
          this.setState({
            errorMessage: LABELS.norecordsarefound,
            loading: false,
          });
        }
      } catch (e) {
        this.setState({ loading: false });
      }
    }
  };

  getEqpLogs = async () => {
    const { vehicleId, start, end } = this.state;
    if (!vehicleId) {
      this.setState({
        errorMessage: LABELS.selectVehicle,
        loading: false,
      });
    } else {
      try {
        this.setState({ loading: true, errorMessage: "", allRoutes: [] });

        const vehicle = this.props.equipments.filter(
          (item) => item.id === vehicleId
        );
        this.setState({ vehicle });
        const dutyLogs = await this.props.getEqpLogs({
          eqpId: vehicleId,
          from: start,
          to: end,
        });

        const _statemiles = dutyLogs.status || [];
        const startLog = _statemiles[0];
        const lastLog = _statemiles[_statemiles.length - 1];
        const startOdometer = parseInt(startLog.odometer);
        const lastOdometer = parseInt(lastLog.odometer);
        const diffOdometer = (lastOdometer - startOdometer).toFixed();

        this.setState({ diffOdometer });

        const allStatus = ((dutyLogs && dutyLogs.status) || []).filter(
          (e) =>
            Array.isArray(e.coordinates) &&
            e.coordinates.length === 2 &&
            e.coordinates[0] !== 0
        );

        if (allStatus && Array.isArray(allStatus) && allStatus.length > 1) {
          this.getStateMileage(allStatus);
        } else {
          this.setState({
            errorMessage: LABELS.norecordsarefound,
            loading: false,
          });
        }
      } catch (e) {
        this.setState({ loading: false });
      }
    }
  };

  getWayPoints = (locations = []) => {
    try {
      let result = {};
      let idx = 0;
      locations.forEach((item) => {
        const _item = item.coordinates;
        if (_item && _item[0]) {
          const keyName = `waypoint${idx}`;

          result[keyName] = `geo!${_item[0]},${_item[1]}`;

          idx++;
        }
      });
      return result;
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  getStateMileage = async (dutyLogs) => {
    try {
      const arrayOfPromises = [];
      const chunkSize = 125;

      for (let i = 0; i < dutyLogs.length; i += chunkSize) {
        const _chunk = dutyLogs.slice(i + 5, i + chunkSize - 5);
        arrayOfPromises.push(this._getStateMileage(_chunk));
      }

      const response = await Promise.all(arrayOfPromises);
      const allRoutes = parseStateMileage(response);

      this.setState({ allRoutes, loading: false, errorMessage: "" });
    } catch (e) {
      console.log(" ************* END ERROR ************* ", e);
      this.setState({
        allRoutes: [],
        loading: false,
        errorMessage: e.errorMessage || "Not able to calculate state mileage",
      });
    }
  };

  _getStateMileage = (dutyLogs, cb) => {
    const { iftaApiKey } = this.props;
    return new Promise((resolve, reject) => {
      try {
        const platform = new window.H.service.Platform({
          apikey: iftaApiKey,
        });
        const allWayPoints = this.getWayPoints(dutyLogs);
        let routingParameters = {
          mode: "shortest;car",
          representation: "display",
          // routeattributes: "waypoints,summary,summaryByCountry,shape,legs",
          routeattributes: "wp,sm,sh,sc",
          maneuverattributes: "direction,action",
          alternatives: 2,
          // metricSystem: 'metric',
          language: "en-us",
          // excludeCountries:['TX'],
          ...allWayPoints,
        };
        const router = platform.getRoutingService();

        router.calculateRoute(
          routingParameters,
          (result) => {
            const response = (result.response && result.response.route) || [];
            const allRoutes = _get(response, "[0].summaryByCountry", []);
            resolve(allRoutes);
          },
          (error) => {
            console.log(error);
            const _error = { errorMessage: "Calculate Ifta for few days" };
            resolve(_error);
          }
        );
      } catch (e) {
        console.log(e);
        resolve(e);
      }
    });
  };

  _getStateMileageOld = async (dutyLogs) => {
    const { iftaApiKey } = this.props;
    try {
      const platform = new window.H.service.Platform({
        apikey: iftaApiKey,
      });
      const allWayPoints = this.getWayPoints(dutyLogs);
      let routingParameters = {
        mode: "fastest;truck",
        representation: "display",
        routeattributes: "waypoints,summary,summaryByCountry,shape,legs",
        maneuverattributes: "direction,action",
        alternatives: 2,
        ...allWayPoints,
      };
      const router = platform.getRoutingService();

      router.calculateRoute(
        routingParameters,
        (result) => {
          // const allRoutes =
          //     (result.response && result.response.route) || [];

          const allRoutes = _get(
            result,
            "response.route[0].summaryByCountry",
            []
          );

          this.setState({ allRoutes, loading: false, errorMessage: "" });
        },
        (error) => {
          this.setState({
            allRoutes: [],
            loading: false,
            errorMessage: "Calculate Ifta for few days",
          });
        }
      );
    } catch (e) {
      this.setState({ loading: false });
    }
  };

  onSearch = ({ vehicleId, vehicle, start, end, prefix }) => {
    this.setState({ vehicleId, vehicle, start, end, prefix }, this.getEqpLogs);
  };

  downloadReport = async () => {
    this.setState({ download: true });
    const fileName = `stateMileage.${"pdf"}`.replace(/ /g, "");
    window.scrollTo(0, 0);
    const element = document.getElementById("print_log");

    pdfOptions.filename = fileName;
    pdfOptions.margin = [0.3, 0.3, 0.3, 0.3];

    await html2pdf().set(pdfOptions).from(element).toPdf().save();
    this.setState({ download: false, saving: true });
  };

  render() {
    const { loading, errorMessage } = this.state;

    return (
      <>
        <SearchBar
          options={{
            isEqp: true,
            isState: false,
            isStartDate: true,
            isEndDate: true,
            isTime: false,
            isTimeperiod: true,
            isPrefix: true,
          }}
          loading={loading}
          onSearch={this.onSearch}
          stateMil={true}
        />

        {errorMessage && (
          <div style={{ margin: "20px" }}>
            <Alert severity="warning">{errorMessage}</Alert>
          </div>
        )}
        {this.state.diffOdometer && (
          <div style={{ marginLeft: 25 }}>
            Odometer: {this.state.diffOdometer}
          </div>
        )}
        <>
          {loading ? (
            <div style={{ textAlign: "center" }}>
              <CircularProgress />
            </div>
          ) : (
            <MileTable
              downloadReport={this.downloadReport}
              allRoutes={this.state.allRoutes}
              vehicle={this.state.vehicle}
              carrier={this.props.carrier}
              start={this.state.start}
              end={this.state.end}
              download={this.state.download}
              vehicleId={this.state.vehicleId}
              prefix={this.state.prefix}
              diffOdometer={this.state.diffOdometer}
            />
          )}
        </>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    equipments: _get(state, "equipmentData.equipments", []),
    adminKey: _get(state, "authData.profile.adminId"),
    carrier: _get(state, "authData.profile.account.carrier.name", ""),
    iftaApiKey: _get(state, "appData.IFTA_KEY", ""),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getIftaLogs,
      formatDate,
      formatTime,
      getEqpLogs,
      updateStateMileage,
      getProfile,
      // getEquipments
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(StateMileage);
